"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ReduxDomFactory", {
  enumerable: true,
  get: function get() {
    return _ReduxDomFactory.default;
  }
});
exports.default = void 0;
var _ReduxDomFactory = _interopRequireDefault(require("./ReduxDomFactory"));
var _default = _ReduxDomFactory.default;
exports.default = _default;